import React from "react";

export const Source: React.FC = ({ children }) => {
  return <div className="cw-mb-4">{children}</div>;
};
